var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg45Empty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1860 5120 l0 -3920 3260 0 3260 0 0 3920 0 3920 -3260 0 -3260 0 0 -3920z m6105 0 l0 -3495 -2847 -3 -2848 -2 0 3493 c0 1922 3 3497 7 3500 3 4 1285 6 2847 5 l2841 -3 0 -3495z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45Empty);
export default __webpack_public_path__ + "static/media/4_5_empty.4d9a4b399ed61a737110b7e37b46d704.svg";
export { ForwardRef as ReactComponent };